import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactSlideToggleUmd from 'react-slide-toggle';
import { connect } from 'react-redux';
import { withRouter } from "../../routes/withRouter";

//Import Utils
import { isIEBrowser, getToken, getUser, removeUserSession, getQtyTotal } from '../../utils';

//Import Data
import MainNav from '../../mock-data/MainNavMobile.json';

//Import Action
import { filterCategories } from '../../action';

function MobileMenu (props) {
  const { categories, cartItems, filterCategories } = props;
  const [ path, setPath ] = useState( "" );
  const token = getToken();
  const user = getUser();
  let location = useLocation();
  let navigate = useNavigate();

  useEffect( () => {
    setPath( window.location.pathname );
  }, []);

  useEffect( () => {
    document.querySelector( ".mobile-menu-overlay" ).addEventListener( "click", closeMobileMenu );
    document.querySelector( ".mobile-menu-close" ).addEventListener( "click", closeMobileMenu );

    return () => {
      if ( document.querySelector( "body" ).classList.contains( "mmenu-active" ) ) {
        document.querySelector( "body" ).classList.remove( "mmenu-active" );
      }
    }
  }, []);

  useEffect(() => {
    if (location.pathname) {
      document.querySelector( "body" ).classList.remove( "mmenu-active" );
    }
  }, [location.pathname]);

  const closeMobileMenu = ( e ) => {
    e.preventDefault();
    document.querySelector( "body" ).classList.remove( "mmenu-active" );
    if ( document.querySelector( ".menu-toggler" ) ) {
      document.querySelector( ".menu-toggler" ).classList.remove( "active" );
    }

    if ( isIEBrowser() && !document.querySelector( "body" ).classList.contains( "mmenu-active" ) ) {
      document.querySelector( ".mobile-menu-container" ).style.transform = "translateX(-100%)";
    }
  }

  const handleLogout = (e) => {
    e.preventDefault();

    removeUserSession();
    navigate('/');
  }

  const getCategory = (e, item) => {
    e.preventDefault();
    filterCategories(item);
    navigate('/produkty');
    closeMobileMenu(e);
  }

  return (
    <>
      <div className="mobile-menu-overlay">
        <span className="mobile-menu-close"><i className="icon-retweet"></i></span>
      </div>
      <div className="mobile-menu-container">
        <div className="mobile-menu-wrapper">
          {user ? <div className="col-12 title-mobile-menu">Cześć {user.name }!</div> : <div className="col-12 title-mobile-menu">Dzień dobry!</div>}
          <nav className="mobile-nav">
            <ul className="mobile-menu">
              {
                token ? 
                  <ReactSlideToggleUmd>
                    {
                      ( { onToggle, setCollapsibleElement, toggleState } ) => (
                        <li style={{borderBottom: '3px solid #ababab'}}>
                          <Link to="#" data-toggle="collapse" onClick={ onToggle } className={ toggleState.toLowerCase() }><i className="icon-user-2"></i> Moje konto
                            <span className="mmenu-btn"></span>
                          </Link>
                          <ul ref={ setCollapsibleElement }>
                            {
                              user.role === "client" ? 
                                MainNav.client.map( ( client, index ) => (
                                  <li className={client.class} key={ "Menu" + index }>
                                    <Link to={ `${ process.env.PUBLIC_URL }/${client.url}` }>{ client.name }</Link>
                                  </li>
                                ))
                              : user.role === "contractor" ?
                                MainNav.contractor.map( ( client, index ) => (
                                  <li className={client.class} key={ "Menu" + index }>
                                    <Link to={ `${ process.env.PUBLIC_URL }/${client.url}` }>{ client.name }</Link>
                                  </li>
                                ))
                              :
                              MainNav.seller.map( ( seller, index ) => (
                                <li className={seller.class} key={ "Menu" + index }>
                                  <Link to={ `${ process.env.PUBLIC_URL }/${seller.url}` }>{ seller.name }</Link>
                                </li>
                              ))
                            }
                            <li>
                              <Link to="#" onClick={handleLogout}>Wyloguj się</Link>
                            </li>
                          </ul>
                        </li>
                      )
                    }
                  </ReactSlideToggleUmd>
                : 
                <li className="special-effect">
                  <Link to={{ pathname: `/logowanie`, state: {from: location.pathname} }}>Zaloguj się</Link>
                </li>
              }
              <li>
                <Link to={ `${ process.env.PUBLIC_URL }/koszyk` }>Koszyk <span className="font-orange">({getQtyTotal(cartItems)})</span></Link>
              </li>
              <ReactSlideToggleUmd collapsed={ true }>
                {
                  ( { onToggle, setCollapsibleElement, toggleState } ) => (
                    <li className={ path.indexOf( "produkty/" ) > -1 ? 'active' : '' }>
                      <Link to="#" data-toggle="collapse" onClick={ onToggle } className={ toggleState.toLowerCase() }>Produkty
                        <span className="mmenu-btn"></span>
                      </Link>
                      <ul ref={ setCollapsibleElement }>
                        {
                          categories.map(category => (
                            category.all_children.length > 0 ? 
                              category.category_active === 1 ? 
                                <ReactSlideToggleUmd collapsed={ true } key={category.category_id}>
                                  {
                                    ( { onToggle, setCollapsibleElement, toggleState } ) => (
                                      <li>
                                        <Link to="#" data-toggle="collapse" onClick={ onToggle } className={ toggleState.toLowerCase() }>{ category.category_name }<span className="mmenu-btn"></span></Link>
                                        <ul ref={ setCollapsibleElement }>
                                          {
                                            category.all_children.map(all_children => (
                                              all_children.all_children.length > 0 ? 
                                                all_children.category_active === 1 ? 
                                                  <ReactSlideToggleUmd collapsed={ true } key={all_children.category_id}>
                                                    {
                                                      ( { onToggle, setCollapsibleElement, toggleState } ) => (
                                                        <li>
                                                          <Link to="#" data-toggle="collapse" onClick={ onToggle } className={ toggleState.toLowerCase() }>{ all_children.category_name }<span className="mmenu-btn"></span></Link>
                                                          <ul ref={ setCollapsibleElement }>
                                                            {
                                                              all_children.all_children.map(all_children => (
                                                                all_children.category_active === 1 ?
                                                                  <ReactSlideToggleUmd collapsed={ true } key={all_children.category_id}>
                                                                    {
                                                                      ( { toggleState } ) => (
                                                                        <li><Link to="#" onClick={(e) => getCategory(e, all_children)} className={ toggleState.toLowerCase() }>{ all_children.category_name }</Link></li>
                                                                      )
                                                                    }
                                                                  </ReactSlideToggleUmd>
                                                                : null
                                                              ))
                                                            }
                                                          </ul>
                                                        </li>
                                                      )
                                                    }
                                                  </ReactSlideToggleUmd>
                                                : null
                                              :
                                              <li key={all_children.category_id}>
                                                <Link to={ `${ process.env.PUBLIC_URL }/produkty/${ all_children.category_slug }` } className={ toggleState.toLowerCase() }>{ all_children.category_name }</Link>
                                              </li>
                                            ))
                                          }
                                        </ul>
                                      </li>
                                    )
                                  }
                                </ReactSlideToggleUmd>
                              : null
                            :
                            category.category_active === 1 ?
                              <li key={category.category_id}>
                                <Link to={ `${ process.env.PUBLIC_URL }/produkty/${ category.category_slug }` } className={ toggleState.toLowerCase() }>{ category.category_name }</Link>
                              </li>
                            : null
                          ))
                        }
                      </ul>
                    </li>
                  )
                }
              </ReactSlideToggleUmd>
              {
                MainNav.menu.map( ( menu, index ) => (
                  <li className={menu.class} key={ "Menu" + index }>
                    <Link to={ `${ process.env.PUBLIC_URL }/${menu.url}` } rel="noopener noreferrer">{ menu.name }</Link>
                  </li>
                ))
              }
            </ul>
          </nav>

          {/* <div className="social-icons">
            <a href="https://www.facebook.com/budujpl" title="Facebook Buduj.pl" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
            <a href="https://www.youtube.com/channel/UC_Q6eLFAdlH-uj5kgmomUDA/videos" title="Youtube Buduj.pl" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
          </div> */}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = ( state ) => {
  return {
    categories: state.categories.categories ? state.categories.categories : [],
    cartItems: state.cartList.cart ? state.cartList.cart : []
  }
}

export default connect(mapStateToProps, { filterCategories })(withRouter(MobileMenu));